import {take} from 'rxjs';
import {disconnect as originDisconnect} from '@wagmi/core';
import {sd} from '@/da';
import {bridge} from '@/helper/bridge';
import {defineWalletConnectBridge, shouldUseAppWalletConnect$} from '../bridge';

const APP_DISCONNECT_METHOD_NAME = 'appDisconnect';
let disconnectCallback;
/**
 * 断开连接
 */
export async function disconnect() {
  try {
    await new Promise((resolve, reject) => {
      shouldUseAppWalletConnect$.pipe(take(1)).subscribe((shouldUseAppWalletConnect) => {
        if (shouldUseAppWalletConnect) {
          bridge.postJSON({type: 'walletDisconnect', callback: APP_DISCONNECT_METHOD_NAME});
          disconnectCallback = resolve;
          return;
        }
        originDisconnect().then(resolve);
      });
    });
  } catch (error) {
    sd.track('wallet-connect:disconnect-error', {message: error?.message});
  }
}

defineWalletConnectBridge(() => {
  (window as any)[APP_DISCONNECT_METHOD_NAME] = function (data) {
    disconnectCallback && disconnectCallback(data);
  };
});
